export const APP_NAME = 'Tychi Desk';
export const APP_SHORT = 'TD';

/** Office locations for assets */
export const ASSET_LOCATIONS = [
  'Raipur Office',
  'Kolkata Office',
  'Bangalore Office',
  'Pune Office',
  'Delhi Office',
];

/** Roles used when assigning workflow / onboarding tasks */
export const WORKFLOW_ROLES = [
  'Hr Operation',
  'IT Support',
  'Fundtec Finance',
  'HR Ops Fundtec',
  'Manager',
  'Tychi',
];

export const TICKET_PRIORITIES = ['Critical', 'High', 'Medium', 'Low'];

export const TIMEZONES = [
  'Asia/Kolkata',
  'Asia/Dubai',
  'Asia/Karachi',
  'Europe/London',
  'America/New_York',
  'America/Los_Angeles',
  'UTC',
];

export const CUSTOM_FIELD_TYPES = ['text', 'number', 'date', 'select', 'checkbox'];

export const CATEGORY_COLORS = [
  '#1a73e8', '#1e8e3e', '#e37400', '#00796b', '#7b1fa2', '#d93025', '#f5a623', '#0097a7',
];

/** Admin settings paths */
export const SETTINGS_FORMS_BASE = '/settings/forms';
